<template lang="html">
  <section class="pages-options">
    <div class="selection">
      <b-form-select
        v-if="displayOptions"
        class="pages-option"
        :value="currentPage"
        v-model="pageInfo.currentPage"
        :options="pagesList"
        size="sm"
      />
      <group-buttons
        id="pages-group-buttons"
        :buttons="buttons"
        @on-group-button-click="onGroupButtonClick"
      />
      <div class="platform-select" v-if="isPreview">
        <div class="label">
          {{ $t("platform") }}
        </div>
        <b-form-select
          class="platform-option"
          :options="platformOptions"
          value="platformSelected"
          text-field="text"
          value-field="value"
          @input="onPlatformChange"
          v-model="previewPlatform"
        ></b-form-select>
      </div>
    </div>
  </section>
</template>

<script lang="js">
  import {mapActions, mapState} from "vuex";
  import {MUTATION_NAME, PLATFORMS} from "@/static/global-variables";
  import GroupButtons from "@/views/drag-drop-pages/components/GroupButtons";
  import store from "@/store";

  export default  {
        name: "pages-options",
        components: {
          GroupButtons
        },
        props: {
          appId: {
            type: String
          }
        },
        computed: {
          ...mapState({
            messages: "messages",
            apps: "apps",
            storedPageInfo: "pageInfo",
            previewPlatform: "previewPlatform"
          }),
          appContent() {
            return JSON.parse(JSON.stringify(this.apps.find(e => e.uuid === this.appId)));
          },
          isPreview() {
            // preview can be boolean when set in the $route.pus() as query param
            // preview can be string when user right clicks on the link and opens either as new tab or window.
            // So need to test preview to be either boolean or string.
            return this.$route.query.preview === true || this.$route.query.preview === "true" ||
              (this.storedPageInfo && this.storedPageInfo.appId === this.appId && this.storedPageInfo.isPreview);
          },
          pagesList() {
            // Adding default page name, but setting default may change once they are allowed to add more pages.
            return this.appContent.pages && this.appContent.pages.length ? this.appContent.pages.map(e => e.name) : ["Main Page"];
          },
          currentPage() {
            return this.storedPageInfo && this.storedPageInfo.currentPage ? this.storedPageInfo.currentPage : this.pagesList[0];
          },
          displayOptions() {
            // Do not show dropdown for this release since only one config/preview page is supported at this time
            return false;
          },
          platformOptions() {
            return [
              {value: PLATFORMS.APP, text: this.$t("app")},
              {value: PLATFORMS.BROWSER, text: this.$t("browser")}
            ];
          },
          buttons() {
            return [{
              id: "page-btn-config",
              text: this.getMessageText(this.messages.CONFIGURATION),
              type: "neutral",
              selected: !this.isPreview
            }, {
              id: "page-btn-preview",
              text: this.getMessageText(this.messages.PREVIEW),
              type: "neutral",
              selected: this.isPreview
            }
            ];
          }
        },
        mounted() {
          this.pageInfo.isPreview = this.isPreview;
          this.pageInfo.appId = this.appId;
          this.pageInfo.currentPage = this.currentPage;
          this.setPageInfo(this.pageInfo);
          this.$router.replace({query: {preview: undefined}});
        },
        data() {
          return {
            pageInfo: {}
          }
        },
        methods: {
          ...mapActions({
            setPageInfo: MUTATION_NAME.SET_PAGE_INFO
          }),
          onGroupButtonClick(ctx) {
            this.pageInfo.isPreview = ctx.button.id === this.buttons[1].id;
            this.setPageInfo(this.pageInfo);
          },
          onPlatformChange(value) {
            store.commit(MUTATION_NAME.SET_PREVIEW_PLATFORM, value);
          }
        }
      }
</script>

<style scoped lang="scss">
  @import "@/styles/components/main";
  @include drag-drop-a-tag;
  .pages-options {
    @include mixin-border;
    border-top: none;
    padding: 1rem;
    .selection {
      display: flex;
      column-gap: 1.5rem;
      .pages-option {
        max-width: fit-content;
        margin-right: 1rem;
      }
    }

    .platform-select {
      display: flex;
      align-items: center;

      .label {
        padding-right: 0.5rem;
      }

      .platform-option {
        width: 7rem;
      }
    }
  }
</style>